<section
    #chartElementRef
    class="agpr-topPosts-container agpr-topPosts-card agpr-contextMenu-parent"
    [id]="id"
>
    <div class="agpr-topPosts-exportMenu agpr-contextMenu top right">
        <agpr-chart-export-menu
            [id]="id + '_export'"
            iconStyleClass="fa-regular fa-arrow-right-from-bracket"
            [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
            (exportMenuClicked)="exportChart($event, chartElementRef)"
            [contextMenu]="true"
            [social]="true"
        ></agpr-chart-export-menu>
    </div>
    <h4 class="agpr-topPosts-heading">
        {{ title | localize }}
        <agpr-dropdown
            [id]="id + '_topPostDropdown'"
            class="agpr-topPosts-heading-metric"
            [style]="dropdownTypes.borderless"
            [agprStyle]="agprComponentStyle.social"
            [options]="options"
            ariaLabel="Social.intelligence.topPosts.dropdownLabel"
            [(ngModel)]="currentSort"
            (ngModelChange)="onSortChange($event)"
            panelStyleClass="agpr-dropdown-panelSocial"
        >
            <div class="agpr-dropdown-panel"></div>
        </agpr-dropdown>
    </h4>
    <div class="agpr-topPosts-socials">
        <agpr-network-radio
            [availableNetworks]="availableNetworkTypes"
            [showReddit]="showReddit"
            (selectedNetwork)="setSocialTypes($event)"
            [ariaLabel]="'Social.intelligence.themeAnalytics.engagement.socialNetworksLabel'"
            [id]="id + '_networkTypes'"
        ></agpr-network-radio>
    </div>

    <div class="agpr-topPosts-mentions" [agprLoading]="!mentions" [agprInlineLoadingIndicator]="true">
        <ul
            [id]="id + '_mentionList'"
            agprListKeyboardNavigation
            [list]="mentions"
            class="agpr-topPosts-mentionsWrapper"
        >
            <li
                *ngFor="let mention of mentions; index as i"
                [attr.aria-label]="mention.headline ?
                    mention.headline :
                    ('MediaType.'+ mention.mediaType.id | localize) + ('Mention.postBy' | localize) + mention.author.name
                "
            >
                <agpr-social-post-feed-card
                    [id]="id + '_socialPostFeedCard_' + i"
                    [mention]="mention"
                    [showImages]="false"
                >
                </agpr-social-post-feed-card>
            </li>
        </ul>
        <div *ngIf="mentions && mentions.length === 0"
            class="agpr-topPosts-noContent"
        >
            <agpr-message
                [severity]="messageSeverities.noContent"
                [style]="agprComponentStyle.social"
            >
                {{ 'Social.postFeed.noContent' | localize }}
            </agpr-message>
        </div>
    </div>

    <!--
    This button is present in the mocks, but not described in the requirements at all, unclear what it's supposed to do
    <div class="agpr-topPosts-viewAllButton">
        <agpr-button
            [id]="id + 'topPosts.viewAll'"
            [label]="'viewAll'"
            [style]="buttonTypesEnum.outline"
            (click)="onViewAll($event)"
        >
        </agpr-button>
    </div>
    -->
</section>
